// Define rbr constants

module.exports = {
  METRIC_COUNTING_RANGE: 4,
  METRIC_COUNTING_SURVEY_YES_NO: 5,
  METRIC_COUNTING_SURVEY_SCALE: 6,
  METRIC_PERCENTAGE: 3,
  HEALTH_GOOD: 1,
  HEALTH_OK: 2,
  HEALTH_RISK: 3,
  PORIORITY_P1: 1,
  PORIORITY_P2: 2,
  PORIORITY_P3: 3,
  PORIORITY_P4: 4,
  PORIORITY_P5: 5,
  PACE_SLOW: 1,
  PACE_STEADY: 2,
  PACE_FAST: 3,
  RBR_TYPE_PRIVATE: 0,
  RBR_TYPE_SHARED: 1,
  RBR_TYPE_ORG: 2,
  RBR_TYPE_PERSONAL: 3,
  RBR_ADD_OBJETIVIES: 'RBR_ADD_OBJETIVIES',
  RBR_REMOVE_OBJETIVIES: 'RBR_REMOVE_OBJETIVIES',
  RBR_SORTING_OBJETIVIES: 'RBR_SORTING_OBJETIVIES',
  RBR_ADD_WS: 'RBR_ADD_WS',
  RBR_REMOVE_WS: 'RBR_REMOVE_WS',
  RBR_SORTING_WS: 'RBR_SORTING_WS',
  RBR_ADD_WATCHLIST: 'RBR_ADD_WATCHLIST',
  RBR_REMOVE_WATCHLIST: 'RBR_REMOVE_WATCHLIST',
  RBR_RELOAD_HOTBOX: 'RBR_RELOAD_HOTBOX',
  RBR_RELOAD_METRICS: 'RBR_RELOAD_METRICS',
  RBR_RELOAD_OBJECTIVES: 'RBR_RELOAD_OBJECTIVES',
  RBR_RELOAD_WS: 'RBR_RELOAD_WS',
  RBR_RELOAD_AI: 'RBR_RELOAD_AI',
  RBR_SAVE_RBR: 'RBR_SAVE_RBR',
  RBR_UPDATE_SHARED_RBR: 'RBR_UPDATE_SHARED_RBR',
  RBR_REMOVE_SHARED_MEMBER: 'RBR_REMOVE_SHARED_MEMBER',
  RBR_ADD_KR: 'RBR_ADD_KR',
  RBR_ADD_AI: 'RBR_ADD_AI',
  RBR_SORTING_AI: 'RBR_SORTING_AI',
  RBR_SORTING_KR: 'RBR_SORTING_KR',
  RBR_REMOVE_KR: 'RBR_REMOVE_KR',
  RBR_REMOVE_AI: 'RBR_REMOVE_AI',
  RBR_ADD_HOTBOX_KR: 'RBR_ADD_HOTBOX_KR',
  RBR_REMOVE_HOTBOX_ITEM: 'RBR_REMOVE_HOTBOX_ITEM',
  RBR_SORTING_HOT_BOX: 'RBR_SORTING_HOT_BOX',
  RBR_RELOAD_TODAY: 'RBR_RELOAD_TODAY',
  RBR_RELOAD_TOMORROW: 'RBR_RELOAD_TOMORROW',
  OBJECT_TYPE_RBR: 'rbr',
  RBR_RELOAD_CHARTS: 'RBR_RELOAD_CHARTS',
  RBR_SAVE_GROUP_ITEM: 'RBR_SAVE_GROUP_ITEM',
  RBR_DELETE_GROUP_ITEM: 'RBR_DELETE_GROUP_ITEM',
  RBR_SAVE_GROUP_NAME: 'RBR_SAVE_GROUP_NAME',
  RBR_ADD_CHART_GROUP: 'RBR_ADD_CHART_GROUP',
  RBR_DELETE_RBR_GROUP: 'RBR_DELETE_RBR_GROUP',
  RBR_EDIT_PAGE: 'RBR_EDIT_PAGE',
  RBR_SORTING_CHARTS: 'RBR_SORTING_CHARTS',
  RBR_UPDATE_ARCHIVE: 'RBR_UPDATE_ARCHIVE',
  RBR_UPDATE_LAYOUT: 'RBR_UPDATE_LAYOUT',
  RBR_GET_COLLECTIONS_PARAMS: {
    orderBy: 'asc',
    sortBy: 'name',
    isCollection: 1,
    isArchived: 0,
    isEditable: 1,
    omitRBRs: 1,
    omitScorecards: 1
  }
};
